import React from 'react';
import ReportPage from './components/ReportPage';
import SLAsByWorkflowsList from './components/SLAsByWorkflowsList';
import { useAppSelector } from '../../hooks';

function SLAsByWorkflows() {
  const currentUser = useAppSelector((state) => state.auth);
  return (
    <ReportPage title="SLAs by workflows">
      <SLAsByWorkflowsList currentUser={currentUser} />
    </ReportPage>
  );
}

export default SLAsByWorkflows;
